const comprobanteISLRTemplateHtml = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Comprobante de Retención ISLR</title>
    <style>
        @page {
            size: A4 portrait;
            margin: 10mm;
        }

        @media print {
            body {
                background: white;
                padding: 0;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
            }
            .comprobante {
                border: 2px solid #000;
                width: 100%;
            }
            input {
                border: none !important;
                background: transparent !important;
            }
            .no-print {
                display: none !important;
            }
        }

        * { margin: 0; padding: 0; box-sizing: border-box; }

        body {
            font-family: "Arial", "Helvetica", sans-serif;
            background: #f5f5f5;
            padding: 20px;
            display: flex;
            justify-content: center;
        }

        .comprobante {
            width: 728px;
            min-height: 816px;
            background: white;
            border: 2px solid #000;
            padding: 12px 18px;
            position: relative;
        }

        .header { margin-bottom: 6px; position: relative; }

        .header h1 {
            font-size: 17px;
            font-weight: bold;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            line-height: 1.2;
        }

        .header-fecha {
            text-align: right;
            font-size: 13px;
            margin-top: 2px;
        }

        .header-fecha input {
            border: none;
            font-size: 13px;
            font-family: Arial, sans-serif;
            width: 110px;
            text-align: left;
            background: transparent;
        }

        .header-numero {
            text-align: right;
            font-size: 22px;
            font-weight: bold;
            margin-top: 2px;
        }

        table {
            width: 100%;
            border-collapse: collapse;
            font-size: 12px;
        }

        th, td {
            border: 1px solid #000;
            padding: 3px 6px;
            text-align: center;
            vertical-align: middle;
        }

        th {
            background: #e0e0e0;
            font-weight: bold;
            font-size: 11.5px;
            text-transform: uppercase;
        }

        input[type="text"],
        input[type="number"],
        input[type="date"],
        input[type="tel"] {
            width: 100%;
            border: none;
            background: transparent;
            text-align: center;
            font-size: 12px;
            font-family: Arial, sans-serif;
            padding: 1px;
            outline: none;
            color: #000;
        }

        input[type="text"]:focus,
        input[type="number"]:focus,
        input[type="date"]:focus {
            background: #fffacd;
        }

        .input-left input { text-align: left; }
        .input-right input { text-align: right; }

        .seccion { margin-bottom: 10px; }

        .seccion-direccion td {
            font-size: 10px;
            text-align: center;
            padding: 3px 6px;
            line-height: 1.3;
        }

        .seccion-direccion input { font-size: 10px; text-align: center; }

        .seccion-concepto { margin-top: 12px; margin-bottom: 10px; }

        .seccion-concepto td { height: 55px; vertical-align: middle; }

        .seccion-concepto input { font-size: 12px; }

        .seccion-montos th { font-size: 11px; padding: 4px 6px; }
        .seccion-montos td { font-size: 13px; padding: 5px 6px; }
        .seccion-montos input { font-size: 13px; font-weight: normal; }

        .seccion-totales th { font-size: 11.5px; padding: 4px 6px; }
        .seccion-totales td { font-size: 13px; padding: 5px 6px; }
        .seccion-totales input { font-size: 13px; }

        .neto-pagar-label {
            background: #e0e0e0;
            font-weight: bold;
            font-size: 11.5px;
            padding: 4px 6px;
        }

        .neto-pagar-valor { font-weight: bold; font-size: 14px; }
        .neto-pagar-valor input { font-size: 14px; font-weight: bold; }

        .firma-section {
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }

        .firma-izquierda { width: 45%; padding-top: 15px; }
        .firma-izquierda .label { font-size: 12px; font-weight: bold; margin-bottom: 35px; }
        .firma-izquierda .linea { border-top: 1px solid #000; width: 100%; margin-bottom: 8px; }
        .firma-izquierda .fecha { font-size: 11px; }
        .firma-izquierda .fecha input {
            border: none;
            border-bottom: 1px solid #000;
            width: 180px;
            font-size: 11px;
            text-align: left;
            background: transparent;
        }

        .firma-derecha { width: 45%; text-align: center; }
        .firma-derecha .sello-area {
            min-height: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 5px;
        }
        .firma-derecha .label { font-size: 12px; font-weight: bold; }
        .firma-derecha .rif { font-size: 10px; margin-top: 3px; }

        .calculado { background: #f9f9f9; }
        .calculado input { background: #f9f9f9; font-weight: normal; }

        .no-print { display: none; }
    </style>
</head>
<body>
    <div class="comprobante">

        <div class="header">
            <h1>COMPROBANTE DE RETENCIÓN IMPUESTO SOBRE LA RENTA</h1>
            <div class="header-fecha">
                FECHA <input type="date" id="fecha_doc">
            </div>
            <div class="header-numero" id="numero_doc"></div>
        </div>

        <div class="seccion">
            <table>
                <tr>
                    <th style="width: 75%;">NOMBRE O RAZÓN SOCIAL DEL AGENTE DE RETENCIÓN</th>
                    <th style="width: 25%;">RIF</th>
                </tr>
                <tr>
                    <td class="input-left">
                        <input type="text" id="agente_nombre" placeholder="Nombre o Razón Social">
                    </td>
                    <td>
                        <input type="text" id="agente_rif" placeholder="J-XXXXXXXX-X">
                    </td>
                </tr>
            </table>

            <table class="seccion-direccion">
                <tr>
                    <th>DIRECCIÓN FISCAL</th>
                </tr>
                <tr>
                    <td>
                        <input type="text" id="agente_direccion" placeholder="Dirección fiscal completa">
                    </td>
                </tr>
            </table>

            <table>
                <tr>
                    <th style="width: 33.33%;">TELÉFONO</th>
                    <th style="width: 33.33%;">CIUDAD</th>
                    <th style="width: 33.33%;">ESTADO</th>
                </tr>
                <tr>
                    <td><input type="tel" id="agente_telefono" placeholder="Teléfono"></td>
                    <td><input type="text" id="agente_ciudad" placeholder="Ciudad"></td>
                    <td><input type="text" id="agente_estado" placeholder="Estado"></td>
                </tr>
            </table>
        </div>

        <div class="seccion">
            <table>
                <tr>
                    <th style="width: 75%;">NOMBRE O RAZÓN SOCIAL DEL SUJETO RETENIDO</th>
                    <th style="width: 25%;">RIF</th>
                </tr>
                <tr>
                    <td class="input-left">
                        <input type="text" id="sujeto_nombre" placeholder="Nombre o Razón Social">
                    </td>
                    <td>
                        <input type="text" id="sujeto_rif" placeholder="J-XXXXXXXX-X">
                    </td>
                </tr>
            </table>

            <table>
                <tr>
                    <th style="width: 33.33%;">TELÉFONO</th>
                    <th style="width: 33.33%;">CIUDAD</th>
                    <th style="width: 33.33%;">ESTADO</th>
                </tr>
                <tr>
                    <td><input type="tel" id="sujeto_telefono" placeholder="Teléfono"></td>
                    <td><input type="text" id="sujeto_ciudad" placeholder="Ciudad"></td>
                    <td><input type="text" id="sujeto_estado" placeholder="Estado"></td>
                </tr>
            </table>
        </div>

        <div class="seccion">
            <table>
                <tr>
                    <th style="width: 33.33%;">FECHA DE EMISIÓN</th>
                    <th style="width: 33.33%;">FACTURA Nº</th>
                    <th style="width: 33.33%;">Nº DE CONTROL</th>
                </tr>
                <tr>
                    <td><input type="date" id="fecha_emision" style="width:110px;"></td>
                    <td><input type="text" id="factura_numero" placeholder="Número"></td>
                    <td><input type="text" id="control_numero" placeholder="00-00000000"></td>
                </tr>
            </table>
        </div>

        <div class="seccion-concepto">
            <table>
                <tr>
                    <th style="width: 25%;">CODIGO</th>
                    <th style="width: 75%;">DESCRIPCION O CONCEPTO</th>
                </tr>
                <tr>
                    <td><input type="text" id="codigo" placeholder="Código"></td>
                    <td><input type="text" id="concepto" placeholder="Descripción del concepto"></td>
                </tr>
            </table>
        </div>

        <div class="seccion-montos">
            <table>
                <tr>
                    <th style="width: 40%;">MONTO OBJETO DE RETENCIÓN</th>
                    <th style="width: 20%;">% RETENIDO</th>
                    <th style="width: 40%;">ISLR RETENIDO</th>
                </tr>
                <tr>
                    <td class="input-right">
                        <input type="number" id="monto_objeto" step="0.01" placeholder="0.00" onchange="calcular()">
                    </td>
                    <td>
                        <input type="number" id="porcentaje" step="0.01" placeholder="0" onchange="calcular()">
                    </td>
                    <td class="input-right calculado">
                        <input type="number" id="islr_retenido" step="0.01" readonly>
                    </td>
                </tr>
            </table>
        </div>

        <div class="seccion-totales">
            <table>
                <tr>
                    <th style="width: 33.33%;">BASE IMPONIBLE</th>
                    <th style="width: 33.33%;">IVA</th>
                    <th style="width: 33.33%;">TOTAL FACTURA</th>
                </tr>
                <tr>
                    <td class="input-right">
                        <input type="number" id="base_imponible" step="0.01" placeholder="0.00" onchange="calcular()">
                    </td>
                    <td class="input-right">
                        <input type="number" id="iva" step="0.01" placeholder="0.00" onchange="calcular()">
                    </td>
                    <td class="input-right calculado">
                        <input type="number" id="total_factura" step="0.01" readonly>
                    </td>
                </tr>
                <tr>
                    <td style="border: none;"></td>
                    <td class="neto-pagar-label">NETO A PAGAR</td>
                    <td class="neto-pagar-valor calculado">
                        <input type="number" id="neto_pagar" step="0.01" readonly>
                    </td>
                </tr>
            </table>
        </div>

        <div class="firma-section">
            <div class="firma-izquierda">
                <div class="label">RECIBI CONFORME</div>
                <div class="linea"></div>
                <div class="fecha">
                    FECHA: <input type="date" id="fecha_recibi">
                </div>
            </div>
            <div class="firma-derecha">
                <div class="sello-area"></div>
                <div class="label">AGENTE DE RETENCIÓN</div>
                <div class="rif">RIF.: <span id="firma_rif"></span></div>
            </div>
        </div>

    </div>

    <script>
        function formatear(num) {
            return num.toFixed(2);
        }

        function calcular() {
            var montoObjeto = parseFloat(document.getElementById('monto_objeto').value) || 0;
            var porcentaje = parseFloat(document.getElementById('porcentaje').value) || 0;
            var baseImponible = parseFloat(document.getElementById('base_imponible').value) || 0;
            var iva = parseFloat(document.getElementById('iva').value) || 0;

            var islr = montoObjeto * (porcentaje / 100);
            document.getElementById('islr_retenido').value = formatear(islr);

            var total = baseImponible + iva;
            document.getElementById('total_factura').value = formatear(total);

            var neto = total - islr;
            document.getElementById('neto_pagar').value = formatear(neto);

            document.getElementById('firma_rif').textContent = document.getElementById('agente_rif').value;
        }

        document.getElementById('fecha_doc').addEventListener('change', function() {
            document.getElementById('fecha_emision').value = this.value;
        });
        document.getElementById('fecha_emision').addEventListener('change', function() {
            document.getElementById('fecha_doc').value = this.value;
        });

        window.renderComprobanteISLR = function(data) {
            function setVal(id, value) {
                var el = document.getElementById(id);
                if (el && value !== undefined && value !== null && value !== '') {
                    el.value = value;
                }
            }
            function setText(id, value) {
                var el = document.getElementById(id);
                if (el && value !== undefined && value !== null && value !== '') {
                    el.textContent = value;
                }
            }

            setVal('fecha_doc', data.fechaEmision);
            setText('numero_doc', data.numero);

            setVal('agente_nombre', data.agente.nombre);
            setVal('agente_rif', data.agente.rif);
            setVal('agente_direccion', data.agente.direccion);
            setVal('agente_telefono', data.agente.telefono);
            setVal('agente_ciudad', data.agente.ciudad);
            setVal('agente_estado', data.agente.estado);

            setVal('sujeto_nombre', data.sujeto.nombre);
            setVal('sujeto_rif', data.sujeto.rif);
            setVal('sujeto_telefono', data.sujeto.telefono);
            setVal('sujeto_ciudad', data.sujeto.ciudad);
            setVal('sujeto_estado', data.sujeto.estado);

            setVal('fecha_emision', data.factura.fechaEmision);
            setVal('factura_numero', data.factura.numero);
            setVal('control_numero', data.factura.numeroControl);

            setVal('codigo', data.islr.codigo);
            setVal('concepto', data.islr.concepto);
            setVal('monto_objeto', data.islr.montoObjeto);
            setVal('porcentaje', data.islr.porcentaje);

            setVal('base_imponible', data.factura.baseImponible);
            setVal('iva', data.factura.iva);

            calcular();

            // calcular() deriva el ISLR retenido como montoObjeto * porcentaje/100,
            // pero el sustraendo (cuando el concepto lo usa) hace que el monto real
            // retenido sea menor. Si el llamador ya trae el monto real calculado en
            // el servidor (fn_calcular_islr), se sobreescribe para no mostrar un
            // numero recalculado que ignora el sustraendo.
            if (data.islr && data.islr.retenido !== undefined && data.islr.retenido !== null) {
                var retenidoReal = parseFloat(data.islr.retenido) || 0;
                setVal('islr_retenido', formatear(retenidoReal));
                var totalFactura = parseFloat(document.getElementById('total_factura').value) || 0;
                setVal('neto_pagar', formatear(totalFactura - retenidoReal));
            }

            if (data.numero) {
                document.title = 'Comprobante ISLR - ' + data.numero;
            }

            if (window !== window.top) {
                var actionBar = document.getElementById('action-bar');
                if (actionBar) actionBar.style.display = 'none';
            }
        };

        window.descargarPDF = function() {
            var element = document.getElementById('retencion-document') || document.querySelector('.comprobante') || document.body;
            var opt = {
                margin: [0.5, 0.5, 0.5, 0.5],
                filename: (document.title || 'Comprobante') + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };
            if (typeof html2pdf !== 'undefined') {
                html2pdf().set(opt).from(element).save();
            } else {
                alert('La librería para generar PDF no está cargada.');
            }
        };
    </script>
</body>
</html>`;

export default comprobanteISLRTemplateHtml;
